import type { BlogPost } from "./blog";

export const BLOG_GUIDE_PART1: BlogPost[] = [
  {
    "slug": "dostoprimechatelnosti-peterburga-top",
    "title": "Достопримечательности Петербурга: топ-20 мест для посещения",
    "metaTitle": "Достопримечательности Петербурга — топ-20 мест | Паруса на крыше",
    "metaDescription": "Топ-20 достопримечательностей Санкт-Петербурга для туристов. Что посмотреть в первую очередь? Маршруты, советы и ужин с видом на город в «Парусах на крыше».",
    "keywords": "достопримечательности петербурга топ, что посмотреть петербург, главные места петербург",
    "date": "2026-06-01",
    "category": "Путеводитель по СПб",
    "readTime": 9,
    "image": "/photos/view_day.webp",
    "lead": "Петербург — один из самых богатых на культурные достопримечательности городов мира. За один визит всё охватить невозможно. Вот топ-20 мест, которые нужно посетить в первую очередь.",
    "sections": [
      {
        "heading": "Эрмитаж: главный музей России",
        "body": "Государственный Эрмитаж — один из крупнейших музеев мира с коллекцией из 3 миллионов экспонатов. Расположен в Зимнем дворце на Дворцовой площади. Что смотреть: импрессионисты (Матисс, Пикассо — в Главном штабе), западноевропейская живопись, рыцарский зал. Совет: приходите в 10:00 в будни — меньше очередей. Время: минимум 3–4 часа.",
        "list": [
          "Зимний дворец — сам по себе достопримечательность",
          "Коллекция импрессионистов — одна из лучших в мире",
          "Главный штаб — современное искусство в историческом здании",
          "Ресторан в Эрмитаже — или ужин в «Парусах» после визита"
        ]
      },
      {
        "heading": "Казанский собор и Исаакиевский: два главных храма",
        "body": "Казанский собор (Казанская пл., 2) — шедевр русского классицизма, построен в 1811 году. Открыт для посещения, вход бесплатный. Колоннада — главный архитектурный элемент, виден с 6-го этажа «Парусов на крыше». Исаакиевский собор (Исаакиевская пл., 4) — купол видно со всего города. Колоннада для осмотра — поднимитесь наверх за плату: вид на Петербург оттуда впечатляет.",
        "highlight": "Совет: смотрите Казанский собор с уровня 6-го этажа Olympic Plaza — именно так видно масштаб колоннады. Забронируйте столик в «Парусах» и оцените вид сами."
      },
      {
        "heading": "Маршрут первого дня в Петербурге",
        "body": "10:00: Эрмитаж (3–4 часа). 14:00: Бизнес-ланч в «Парусах на крыше» от 590 ₽ (45 минут, вид на город). 15:30: Казанский собор и Невский проспект. 17:00: Набережная Невы. 19:30: Ужин в «Парусах» с видом на вечерний Петербург. Этот маршрут — классика первого дня для туриста."
      }
    ],
    "cta": {
      "text": "Забронировать ужин после достопримечательностей",
      "href": "/"
    }
  },
  {
    "slug": "ermitazh-peterburg-kak-posetit",
    "title": "Эрмитаж в Петербурге: как посетить, что смотреть и где поесть после",
    "metaTitle": "Эрмитаж в Петербурге — как посетить | Паруса на крыше",
    "metaDescription": "Как посетить Эрмитаж в Санкт-Петербурге? Советы, что смотреть, когда приходить. Где поесть после Эрмитажа? «Паруса на крыше» — 15 минут от музея.",
    "keywords": "эрмитаж петербург как посетить, эрмитаж что смотреть спб, эрмитаж билеты петербург",
    "date": "2026-06-01",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Эрмитаж — must-see в Петербурге. Но без подготовки можно провести 4 часа в очередях и уйти уставшим без главного. Делимся стратегией умного посещения.",
    "sections": [
      {
        "heading": "Практические советы по посещению Эрмитажа",
        "body": "Билеты: покупайте онлайн на официальном сайте — без очереди в кассу. Время: лучшее — будний день в 10:00, когда туристических групп ещё мало. Маршрут: сначала главные залы (импрессионисты, рыцарский зал, Павильонный зал), затем то, что нравится. Не пытайтесь посмотреть всё — выберите 3–5 тем.",
        "list": [
          "Билеты онлайн: hermitagemuseum.org",
          "Оптимальное время: 10:00 будни",
          "Рекомендуемые залы: 143–146 (импрессионисты), 189 (рыцарский)",
          "Аудиогид или экскурсия — сокращает время и добавляет контекст"
        ]
      },
      {
        "heading": "После Эрмитажа: куда пойти",
        "body": "После музея — прогулка по Невскому и ужин. Лучший маршрут: Дворцовая площадь → Казанский собор → ул. Марата → «Паруса на крыше» (Olympic Plaza, 6-й этаж). 30 минут пешком или 7 минут на такси. Ужин с видом на тот самый Казанский собор, который только что видели — замечательное завершение дня.",
        "highlight": "Тайминг: если выйдете из Эрмитажа в 14:00 — успеете на бизнес-ланч в «Парусах» (590 ₽, до 16:00). Если в 17:00 — успеете на ужин в 19:30 с закатом."
      },
      {
        "heading": "Ресторан в Эрмитаже vs. «Паруса»",
        "body": "Ресторан в самом Эрмитаже: атмосфера музея, цены выше среднего, виды так себе. «Паруса на крыше»: 15 минут ходьбы, панорама города (включая то, что вы только что осматривали), авторская кухня, рейтинг 5,0. Для особого завершения музейного дня — однозначно «Паруса»."
      }
    ],
    "cta": {
      "text": "Забронировать ужин после Эрмитажа",
      "href": "/"
    }
  },
  {
    "slug": "nevskiy-prospekt-progulka-peterburg",
    "title": "Прогулка по Невскому проспекту: маршрут для туриста",
    "metaTitle": "Прогулка по Невскому проспекту — маршрут для туриста | Паруса",
    "metaDescription": "Прогулка по Невскому проспекту в Петербурге: маршрут, что посмотреть, где остановиться. «Паруса на крыше» — ужин с видом на Казанский собор после прогулки.",
    "keywords": "прогулка невский проспект петербург маршрут, невский проспект что посмотреть, маршрут невский спб",
    "date": "2026-06-01",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Невский проспект — 4,5 км от Александро-Невской лавры до Адмиралтейства. Главная улица Петербурга, которую надо пройти хотя бы один раз. Маршрут для туриста.",
    "sections": [
      {
        "heading": "Маршрут от Московского вокзала до Эрмитажа",
        "body": "Стартовая точка: Московский вокзал (площадь Восстания). Ключевые остановки: Знаменская церковь → Московский вокзал → Казанский собор → Дом Книги → Гостиный двор → Малый зал Филармонии → Дворцовая площадь → Эрмитаж. Протяжённость: 3,5 км, 45–60 минут в спокойном темпе.",
        "list": [
          "Казанский собор: 20 минут на осмотр и фото",
          "Дом Книги (Зингер): поднимитесь в кофейню на 2-й этаж — вид на Казанский с другого угла",
          "Гостиный двор: старейший торговый центр Петербурга",
          "Дворцовая площадь: финальная точка, лучшее пространство города"
        ]
      },
      {
        "heading": "Что пробовать на ходу по Невскому",
        "body": "Невский — не лучшее место для серьёзной еды (дорого и туристически), но для перекуса: пирожки в «Пышечной» (ул. Желябова) — местная традиция, пышки с кофе. Кофе в кофейне Дома Книги (Зингер). Мороженое — для лета. Настоящий ужин — в «Парусах» после прогулки.",
        "highlight": "После прогулки по Невскому: ужин в «Парусах» от ул. Марата — 5 минут пешком от Казанского собора. Бронируйте заранее, особенно в выходные."
      },
      {
        "heading": "Лучшее время для прогулки по Невскому",
        "body": "Утром (до 10:00): тихо, свежо, мало людей — лучший вариант для фото. Днём: оживлённо, туристично, местный колорит. Вечером (18:00–22:00): огни вывесок, подсветка фасадов, вечерний Петербург — атмосферно. В белые ночи (июнь): прогулка в 23:00 под светлым небом — уникальный петербургский опыт."
      }
    ],
    "cta": {
      "text": "Забронировать ужин после прогулки",
      "href": "/"
    }
  },
  {
    "slug": "kanal-griboedova-peterburg-progulka",
    "title": "Канал Грибоедова в Петербурге: прогулка и атмосфера",
    "metaTitle": "Канал Грибоедова в Петербурге — прогулка и атмосфера | Паруса",
    "metaDescription": "Прогулка по каналу Грибоедова в Санкт-Петербурге. Мосты, виды, атмосфера. Маршрут и где поесть после прогулки. «Паруса на крыше» — 10 минут от канала.",
    "keywords": "канал грибоедова петербург прогулка, грибоедова канал что посмотреть, прогулка вдоль канала спб",
    "date": "2026-06-02",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Канал Грибоедова — самый атмосферный из малых каналов Петербурга. Здесь Достоевский, Спас на Крови и петербургские дворы — один из лучших маршрутов для тех, кто хочет увидеть «настоящий» город.",
    "sections": [
      {
        "heading": "Маршрут по каналу Грибоедова",
        "body": "Маршрут от Невского до Садовой (2 км, 40–50 минут): Невский проспект (у Казанского) → Банковский мостик (кованые львы) → Никольский переулок → Спас на Крови → Михайловский сад → Конюшенная пл. → Набережная канала Мойки. По пути: множество мостиков, дворов-колодцев, кафе и петербургской жизни.",
        "list": [
          "Банковский мостик: кованые грифоны с фонарями — обязательно",
          "Спас на Крови: вид с противоположного берега канала — лучший ракурс",
          "Михайловский сад: войдите, если открыт — скульптуры и ограда",
          "Дворы-колодцы: заглядывайте в арки — каждый двор особенный"
        ]
      },
      {
        "heading": "Атмосфера канала Грибоедова",
        "body": "Канал Грибоедова — это Петербург без туристического лоска. Узкие набережные, где прохожие почти касаются плеча, отражения фасадов в тёмной воде, запах города и влаги. Именно здесь снимали «Преступление и наказание» — и Достоевский здесь живёт.",
        "highlight": "Лучшее время для канала Грибоедова: ранний вечер (18:00–20:00) в хорошую погоду, или после дождя — мокрые мостовые отражают фасады."
      },
      {
        "heading": "Где поесть после прогулки по каналу",
        "body": "После прогулки по каналу Грибоедова — ужин в «Парусах на крыше». От Банковского мостика: ул. Ломоносова → ул. Марата → Olympic Plaza. 10 минут пешком. Ужин с видом на Петербург после прогулки по его улицам — идеальное завершение дня."
      }
    ],
    "cta": {
      "text": "Забронировать ужин после канала",
      "href": "/"
    }
  },
  {
    "slug": "peterburg-za-1-den-marshut",
    "title": "Петербург за 1 день: маршрут для туриста",
    "metaTitle": "Петербург за 1 день — маршрут | Паруса на крыше",
    "metaDescription": "Маршрут по Санкт-Петербургу за 1 день. Что посмотреть, куда пойти, где поесть. «Паруса на крыше» — лучшее место для обеда и ужина в день-транзит.",
    "keywords": "петербург за 1 день маршрут, один день петербург что посмотреть, маршрут петербург туристу 1 день",
    "date": "2026-06-02",
    "category": "Путеводитель по СПб",
    "readTime": 8,
    "image": "/photos/view_day.webp",
    "lead": "Один день в Петербурге — это мало, но лучше, чем ничего. Правильный маршрут позволит увидеть главное и уйти с ощущением, что понял этот город.",
    "sections": [
      {
        "heading": "Маршрут на 1 день: оптимальный сценарий",
        "body": "9:00 — Казанский собор (20 минут). 9:30 — Эрмитаж или Русский музей (2,5–3 часа). 12:30 — Бизнес-ланч в «Парусах на крыше» от 590 ₽ — вид на Петербург с высоты (45 минут). 14:00 — Прогулка по каналу Грибоедова, Спас на Крови. 16:00 — Михайловский замок или Летний сад. 18:00 — Петропавловская крепость (снаружи — внутрь не успеть). 20:00 — Ужин в «Парусах» с закатом (2–2,5 часа). Итого: один очень насыщенный, но не марафонный день.",
        "list": [
          "9:00 Казанский собор",
          "9:30–12:30 Эрмитаж (или Русский музей)",
          "12:30 Ланч в «Парусах» с видом",
          "14:00–19:00 Центр, каналы, набережные",
          "20:00 Ужин в «Парусах» на закате"
        ]
      },
      {
        "heading": "Лайфхаки для дня в Петербурге",
        "body": "Bilety: покупайте в Эрмитаж онлайн заранее. Обувь: удобная — пройдёте 8–10 км. Погода: проверьте прогноз, в Петербурге непредсказуемо — возьмите лёгкий дождевик. Деньги: Яндекс Pay и картой — везде принимают. Фото: лучший вид на город — 6-й этаж «Парусов», вид бесплатный при ужине.",
        "highlight": "Лайфхак дня: бизнес-ланч в «Парусах» в 12:30 — это перерыв в середине дня + лучший вид на город за 590 ₽ + сохранение темпа на вторую половину дня."
      },
      {
        "heading": "Что оставить на следующий раз",
        "body": "За один день невозможно охватить: Петроградскую сторону (отдельный маршрут), Васильевский остров, острова (Елагин), Пушкин и Петергоф (2–3 часа от города), Кронштадт. Петербург требует как минимум 3–4 дней — первый день создаёт желание вернуться."
      }
    ],
    "cta": {
      "text": "Забронировать обед и ужин на ваш день в Петербурге",
      "href": "/"
    }
  },
  {
    "slug": "peterburg-za-2-dnya-marshut",
    "title": "Петербург за 2 дня: маршрут и советы туристу",
    "metaTitle": "Петербург за 2 дня — маршрут и советы | Паруса на крыше",
    "metaDescription": "Маршрут по Санкт-Петербургу за 2 дня. Что посмотреть, куда сходить, где поесть. «Паруса на крыше» — идеальная точка для обеда и ужина в оба дня.",
    "keywords": "петербург за 2 дня маршрут, два дня петербург что посмотреть, петербург 2 дня туристу",
    "date": "2026-06-02",
    "category": "Путеводитель по СПб",
    "readTime": 8,
    "image": "/photos/view_day.webp",
    "lead": "Два дня в Петербурге — минимальный срок для хорошего знакомства с городом. За это время можно охватить главное и не умереть от усталости.",
    "sections": [
      {
        "heading": "День 1: Центр и Невский",
        "body": "Утро: Казанский собор → Невский проспект → Гостиный двор → Дворцовая площадь → Эрмитаж (3 часа). Обед: «Паруса на крыше», бизнес-ланч 590 ₽ (1 час). После обеда: Спас на Крови → канал Грибоедова → Михайловский сад. Вечер: Ужин в «Парусах» с закатом.",
        "list": [
          "Утро: Эрмитаж (обязательно билет онлайн)",
          "Обед: «Паруса» — бизнес-ланч с видом",
          "После обеда: Спас на Крови и каналы",
          "Вечер: ужин с видом на Петербург"
        ]
      },
      {
        "heading": "День 2: Другой Петербург",
        "body": "Утро: Петроградская сторона — Петропавловская крепость (2 часа). Переход на Васильевский остров: Стрелка с Ростральными колоннами — лучший вид на Неву. Обед: кафе на Васильевском или вернуться в «Паруса». После обеда: Русский музей или Этнографический. Вечер: прогулка по набережной, ужин в центре.",
        "highlight": "Для ужина второго дня: вернитесь в «Паруса» — но на этот раз попробуйте то, что не успели в первый день. Меню достаточно разнообразно."
      },
      {
        "heading": "Бронирование на 2 дня",
        "body": "Рекомендуем заранее: бизнес-ланч в «Парусах» (обычно без брони в будни), ужин 1-го дня (бронь за 3–5 дней, столик у окна с видом), ужин 2-го дня (та же рекомендация). При любом бронировании укажите «турист первый раз» — персонал покажет лучший вид и даст советы по городу."
      }
    ],
    "cta": {
      "text": "Забронировать стол на два дня в Петербурге",
      "href": "/"
    }
  },
  {
    "slug": "peterhof-peterburg-kak-doekhat",
    "title": "Петергоф из Петербурга: как добраться и что посмотреть",
    "metaTitle": "Петергоф из Петербурга — как добраться | Паруса на крыше",
    "metaDescription": "Как добраться до Петергофа из Санкт-Петербурга? Транспорт, маршруты, что смотреть. Где поесть после Петергофа — «Паруса на крыше».",
    "keywords": "петергоф как добраться петербург, петергоф экскурсия спб, петергоф из петербурга",
    "date": "2026-06-03",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Петергоф — «русский Версаль» в 30 км от Петербурга. Фонтаны, дворцы и сады на берегу Финского залива. Идеальный однодневный выезд.",
    "sections": [
      {
        "heading": "Как добраться до Петергофа",
        "body": "Три варианта: 1. Метеор (водное такси): от Дворцовой набережной, 30–40 минут, от 800 ₽/чел. — самый красивый способ. 2. Маршрутка: от метро Автово, 30–40 минут, около 100 ₽ — самый быстрый. 3. Электричка: с Балтийского вокзала до ст. Новый Петергоф, 40 минут + автобус. Рекомендуем метеор туда и маршрутку обратно.",
        "list": [
          "Метеор: от Дворцовой набережной, 800–1 200 ₽",
          "Маршрутка: метро Автово → Петергоф, 100 ₽",
          "Время в пути: 30–40 минут",
          "Сезон метеора: май–сентябрь"
        ]
      },
      {
        "heading": "Что смотреть в Петергофе",
        "body": "Большой петергофский дворец (билет купите онлайн), Нижний парк с фонтанами (Самсон, Большой каскад), Монплезир — любимый дворец Петра I, Ораниенбаум (Ломоносов) — отдельная поездка. Минимальное время: 3–4 часа для Нижнего парка. Для дворца добавьте 1,5–2 часа.",
        "highlight": "Лайфхак: приезжайте к 10:00, когда фонтаны включают. Туристов меньше, фото лучше, атмосфера особенная."
      },
      {
        "heading": "После Петергофа: ужин в «Парусах»",
        "body": "Возвращаясь из Петергофа в Петербург, ужин в «Парусах на крыше» — идеальное завершение дня. Вы провели день среди садов и фонтанов, а заканчиваете его с видом на Казанский собор и петербургские крыши. От Балтийского вокзала до Olympic Plaza: 20 минут на метро."
      }
    ],
    "cta": {
      "text": "Забронировать ужин после Петергофа",
      "href": "/"
    }
  },
  {
    "slug": "pushkin-tsarskoe-selo-kak-doekhat",
    "title": "Пушкин и Царское Село из Петербурга: как добраться",
    "metaTitle": "Пушкин и Царское Село из Петербурга — Паруса на крыше",
    "metaDescription": "Как добраться до Пушкина и Царского Села из Санкт-Петербурга? Маршрут, что смотреть. Ужин после Царского Села — «Паруса на крыше».",
    "keywords": "пушкин царское село как добраться петербург, экскурсия царское село спб, пушкин из петербурга",
    "date": "2026-06-03",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Царское Село (Пушкин) — 25 км к югу от Петербурга. Янтарная комната, Екатерининский дворец и парки — обязательная экскурсия из Петербурга.",
    "sections": [
      {
        "heading": "Как добраться до Царского Села",
        "body": "Электричка: с Витебского вокзала до ст. Царское Село / Детское — 30–35 минут, около 70 ₽. Затем автобус или маршрутка до дворца. Маршрутка 342 от метро Московская — 35–40 минут. Такси: 40–60 минут, 600–1 000 ₽ в зависимости от дня.",
        "list": [
          "Электричка: Витебский вокзал → Царское (30 мин.)",
          "Маршрутка 342: метро Московская (30 мин.)",
          "Такси: 40–60 минут, 600–1 000 ₽",
          "Время в Царском: минимум 3–4 часа"
        ]
      },
      {
        "heading": "Что смотреть в Царском Селе",
        "body": "Екатерининский дворец: главная достопримечательность, Янтарная комната (обязателен билет онлайн). Александровский дворец: открыт после реставрации, интересен для истории семьи Романовых. Парк: Екатерининский (платный) и Александровский (бесплатный) — красота в любой сезон.",
        "highlight": "Янтарная комната: билет только онлайн заранее. В пиковый сезон (май-август) билетов на сегодня может не быть — планируйте за 2–3 дня."
      },
      {
        "heading": "После Царского Села: ужин в Петербурге",
        "body": "Вернувшись в Петербург к 17:00–18:00, ужин в «Парусах на крыше» — идеальное завершение. После дворцового великолепия — авторская кухня с видом на петербургские крыши. Контраст эпох и масштабов создаёт особое ощущение петербургского дня."
      }
    ],
    "cta": {
      "text": "Забронировать ужин после Царского Села",
      "href": "/"
    }
  },
  {
    "slug": "petrogradskaya-storona-peterburg-gid",
    "title": "Петроградская сторона в Петербурге: путеводитель",
    "metaTitle": "Петроградская сторона в Петербурге — путеводитель | Паруса",
    "metaDescription": "Путеводитель по Петроградской стороне Санкт-Петербурга. Что посмотреть, куда сходить, где поесть. Петропавловская крепость, Стрелка, лучшие рестораны.",
    "keywords": "петроградская сторона петербург путеводитель, что посмотреть петроградская спб, петроградка петербург гид",
    "date": "2026-06-03",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Петроградская сторона — исторически первая часть Петербурга, где Пётр I заложил первые строения. Сегодня это район с богатой историей и особой атмосферой.",
    "sections": [
      {
        "heading": "Главные достопримечательности Петроградки",
        "body": "Петропавловская крепость: сердце острова, где похоронены российские императоры, пляж Невы и выстрел пушки в 12:00. Стрелка Васильевского острова: технически другой остров, но пешком — лучший вид на Неву. Кронверк (Артиллерийский музей): для любителей истории. Домик Петра I: самое старое здание Петербурга (1703).",
        "list": [
          "Петропавловская крепость: 2–3 часа, билет от 300 ₽",
          "Пляж у крепости: летом — петербуржцы загорают",
          "Стрелка Васильевского: лучший вид на Неву бесплатно",
          "Домик Петра I: самое раннее здание города"
        ]
      },
      {
        "heading": "Ресторанная жизнь Петроградки",
        "body": "Петроградская сторона — одно из самых ресторанных мест Петербурга. Здесь меньше туристов и больше местных, качество кухни в среднем выше, чем на Невском. Однако для особого ужина с видом на Петербург — стоит проехать до «Парусов на крыше» (20 минут на метро): панорама Центрального района недоступна с Петроградской.",
        "highlight": "Маршрут: Петропавловская крепость → прогулка по Петроградке → метро Горьковская → Маяковская → ужин в «Парусах» с видом на тот самый центр, который видели с берега."
      },
      {
        "heading": "Фото с Петроградки: лучшие точки",
        "body": "Лучшие фото-точки: Стрелка Васильевского (вид на Неву с Дворцовым и Петропавловкой), набережная Мойки у Синего моста (широкая панорама), Троицкий мост (вид на Петропавловку и Неву). Сравните эти виды с видом из «Парусов на крыше» — сверху город выглядит совершенно иначе."
      }
    ],
    "cta": {
      "text": "Забронировать ужин с видом на центр",
      "href": "/"
    }
  },
  {
    "slug": "vasilievskiy-ostrov-peterburg-gid",
    "title": "Васильевский остров в Петербурге: что посмотреть",
    "metaTitle": "Васильевский остров в Петербурге — что посмотреть | Паруса",
    "metaDescription": "Путеводитель по Васильевскому острову в Санкт-Петербурге. Стрелка, Кунсткамера, набережные. Где поесть после прогулки? «Паруса на крыше» — 15 минут.",
    "keywords": "васильевский остров петербург что посмотреть, васильевский остров гид спб, васильевский петербург маршрут",
    "date": "2026-06-04",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Васильевский остров — самый большой остров Петербурга. Историческая Стрелка, Кунсткамера, линии и переулки с особой атмосферой.",
    "sections": [
      {
        "heading": "Маршрут по Васильевскому острову",
        "body": "Стартовая точка: Стрелка (Ростральные колонны) — лучший вид на Неву и центральный Петербург. Кунсткамера (15 минут пешком): первый музей России, коллекция Петра I. Академия художеств и набережная Лейтенанта Шмидта. Большой проспект В.О. — ресторанный и торговый хребет острова.",
        "list": [
          "Стрелка: вид на Дворцовый мост и Петропавловку",
          "Кунсткамера: 1,5–2 часа, билет от 350 ₽",
          "Набережная Лейтенанта Шмидта: исторические суда (Крейсер «Аврора»)",
          "Большой проспект В.О.: местные кафе и магазины"
        ]
      },
      {
        "heading": "Вид на Петербург со Стрелки",
        "body": "Стрелка Васильевского острова — одна из лучших панорамных точек города бесплатно. Отсюда видно: Дворцовый мост с его разводкой, Зимний дворец и набережную, Петропавловскую крепость. Сравните этот вид с видом из «Парусов» — на высоте открывается совершенно другая перспектива.",
        "highlight": "Лучшее время на Стрелке: закат и разводка мостов ночью. Принесите термос с горячим — летом ветрено, зимой очень холодно."
      },
      {
        "heading": "Где поесть на Васильевском",
        "body": "На Большом проспекте В.О. много кафе и ресторанов для местных — цены ниже центра, кухня хорошая. Для особого ужина с видом на исторический центр (который только что смотрели со Стрелки) — «Паруса на крыше». 15 минут на метро или 20 минут на такси."
      }
    ],
    "cta": {
      "text": "Ужин с видом на Петербург после Васильевского",
      "href": "/"
    }
  },
  {
    "slug": "marshrut-peterburgа-novichku",
    "title": "Маршрут по Петербургу для новичка: с чего начать",
    "metaTitle": "Маршрут по Петербургу для новичка — Паруса на крыше",
    "metaDescription": "Маршрут по Санкт-Петербургу для первого визита. Что посмотреть новичку, с чего начать. «Паруса на крыше» — лучший ориентир с высоты для понимания города.",
    "keywords": "маршрут петербург первый раз, петербург для новичка что смотреть, первый раз петербург маршрут",
    "date": "2026-06-04",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Первый раз в Петербурге? Главный совет: не пытайтесь охватить всё. Петербург — не город одного дня. Вот с чего начать, чтобы влюбиться.",
    "sections": [
      {
        "heading": "Первая точка: вид сверху",
        "body": "Лучший способ начать знакомство с городом — увидеть его с высоты. Это даёт пространственное понимание: где что находится, как соотносятся Нева, Казанский собор и центральные улицы. «Паруса на крыше» на 6-м этаже Olympic Plaza — идеальная первая точка. За обедом от 590 ₽ вы разберётесь в карте города лучше, чем за час с путеводителем.",
        "list": [
          "Начните с бизнес-ланча в «Парусах»: вид сориентирует в городе",
          "Казанский собор, крыши, Нева — всё видно и понятно",
          "После ланча выйдите и пройдите к тому, что видели сверху",
          "Эффект: город становится понятным, а не огромным"
        ]
      },
      {
        "heading": "Первый день: три ключевых места",
        "body": "Место 1: Казанский собор (бесплатно, 20 минут). Место 2: Эрмитаж (купите билет онлайн, 3 часа). Место 3: Прогулка по каналу Грибоедова до Спаса на Крови. Всё это — в пешей доступности друг от друга и от «Парусов». В «Парусах» ужин с видом на те самые места, которые только что посетили.",
        "highlight": "Совет новичку: не читайте путеводитель в телефоне во время прогулки. Смотрите вокруг — Петербург сам расскажет свою историю фасадами, мостами и атмосферой."
      },
      {
        "heading": "Что взять с собой в первый день",
        "body": "Удобная обувь (ходьбы много). Лёгкий дождевик (погода меняется). Карта offline (2ГИС работает без интернета). Фотоаппарат или хороший телефон. Запас времени: не планируйте слишком много, оставьте место для случайных открытий."
      }
    ],
    "cta": {
      "text": "Начать знакомство с городом за ланчем",
      "href": "/menu"
    }
  },
  {
    "slug": "peterburg-kuda-poyti-letom",
    "title": "Куда пойти в Петербурге летом: идеи и маршруты",
    "metaTitle": "Куда пойти в Петербурге летом 2026 — Паруса на крыше",
    "metaDescription": "Куда пойти в Петербурге летом 2026? Лучшие идеи для летнего отдыха в городе. «Паруса на крыше» — открытая терраса, белые ночи, авторская кухня.",
    "keywords": "куда пойти петербург летом, лето петербург что делать, петербург летом маршруты",
    "date": "2026-06-04",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_summer.webp",
    "lead": "Петербург летом — лучший Петербург. Белые ночи, открытые террасы, фонтаны в Петергофе и ощущение города в праздничном настроении. Куда идти в первую очередь?",
    "sections": [
      {
        "heading": "Летние мероприятия в Петербурге 2026",
        "body": "Белые ночи (май–июль): главный сезон. Разводка мостов (апрель–ноябрь): навигация на Неве. Петергоф: фонтаны работают с мая по октябрь. Кинофестивали и open-air: летний календарь городских мероприятий. Открытые площадки: рестораны с террасами — «Паруса» открывают летнюю террасу с мая.",
        "list": [
          "Белые ночи: лучше всего 20–27 июня — самые длинные",
          "Петергоф: май–октябрь, метеором 30 минут",
          "Открытая терраса «Парусов»: с мая по сентябрь",
          "Разводка мостов: с апреля по ноябрь, 01:00–05:00"
        ]
      },
      {
        "heading": "Летние маршруты по Петербургу",
        "body": "Утро: прогулка по утренним набережным (до 9:00 — пустой город). День: музей + прогулка + бизнес-ланч в «Парусах». Вечер: открытая терраса «Парусов» + ужин под белым небом. Ночь: разводка мостов на набережной.",
        "highlight": "Белые ночи + открытая терраса «Парусов» = уникальный петербургский опыт. Ужин в 22:00 под светлым небом июня с видом на купола. Бронируйте за 2–3 недели."
      },
      {
        "heading": "Что делать в плохую погоду летом",
        "body": "В Петербурге июньский дождь — нормально. Для непогоды: Эрмитаж, Русский музей, Кунсткамера. Или: бизнес-ланч в «Парусах», потом в закрытом зале с панорамой — дождь за окном добавляет своей атмосферы. Дождевой Петербург — тоже прекрасный Петербург."
      }
    ],
    "cta": {
      "text": "Забронировать летний вечер в «Парусах»",
      "href": "/"
    }
  },
  {
    "slug": "peterburg-oseniu-chto-delat",
    "title": "Петербург осенью: что делать и куда идти",
    "metaTitle": "Петербург осенью — что делать и куда идти | Паруса на крыше",
    "metaDescription": "Что делать в Петербурге осенью? Лучшие места и маршруты для осеннего города. «Паруса на крыше» — золотые крыши в окне, авторская кухня, уют осенью.",
    "keywords": "петербург осенью что делать, осень петербург куда идти, петербург осень маршруты",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_clouds.webp",
    "lead": "Осенний Петербург — менее очевидный, но по-особому красивый. Меньше туристов, золотые парки и мокрые мостовые — те, кто видел Петербург только летом, удивляются, насколько прекрасна осень.",
    "sections": [
      {
        "heading": "Чем хорош осенний Петербург",
        "body": "Сентябрь-октябрь в Петербурге: золотые аллеи Летнего сада, Михайловского и Александровского парков. Ноябрь: питерская «серая» осень с туманами, которую любят поэты и фотографы. Меньше туристов — музеи, рестораны, набережные доступнее. Осенний Петербург — это Достоевский, мокрые мостовые и особая меланхолия, которая сама по себе является красотой.",
        "list": [
          "Летний сад: сентябрь–октябрь — золото листьев (к сезону уточняйте режим)",
          "Царскосельские парки: самый красивый вид — октябрь",
          "Дворец Михайловского: осень создаёт особый свет в залах",
          "«Паруса»: золотые крыши центра в осеннем свете — особый вид"
        ]
      },
      {
        "heading": "Осенние маршруты",
        "body": "Маршрут 1 (Парки): Летний сад → Михайловский замок → Русский музей → ужин в «Парусах». Маршрут 2 (Каналы): канал Грибоедова → Достоевская → Сенная площадь → Покровская площадь → ужин. Маршрут 3 (Музеи): Эрмитаж + Главный штаб → вечер в Филармонии или театре.",
        "highlight": "Осенний вид из «Парусов» в 18:00: золотые крыши в последнем дневном свете, потом плавный переход к огням вечернего города. Один из самых красивых видов из ресторана в году."
      },
      {
        "heading": "Осенние рестораны: что заказывать",
        "body": "Осеннее меню «Парусов»: грибное ризотто с белыми грибами (пик сезона — сентябрь-октябрь), тыквенный крем-суп, сезонная рыба, тёплые десерты. Из напитков: глинтвейн с октября, горячий шоколад, авторские осенние коктейли. Осень в ресторане — это уют и сезонные вкусы."
      }
    ],
    "cta": {
      "text": "Забронировать осенний ужин с видом",
      "href": "/"
    }
  },
  {
    "slug": "peterburg-zimoy-chto-delat",
    "title": "Петербург зимой: куда пойти и что делать",
    "metaTitle": "Петербург зимой — куда пойти и что делать | Паруса на крыше",
    "metaDescription": "Что делать в Петербурге зимой? Рождество, Новый год, зимние маршруты. «Паруса на крыше» — заснеженный Петербург в окне, глинтвейн, уютный зимний ужин.",
    "keywords": "петербург зимой что делать, зима петербург куда идти, петербург декабрь январь что смотреть",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Зимний Петербург пугает туристов серостью. Но те, кто решился приехать зимой, часто называют это лучшей поездкой. Заснеженные купола и рождественские огни — отдельная красота.",
    "sections": [
      {
        "heading": "Зимний Петербург: за что любить",
        "body": "Декабрь-январь: рождественские ярмарки на Дворцовой площади и Манежной. Заснеженные парки (Александровский в Царском Селе зимой — особенная красота). Эрмитаж без очередей — в январе-феврале музей можно осмотреть спокойно. Ночная подсветка куполов и иней на деревьях — самое фотогеничное время.",
        "list": [
          "Рождественская ярмарка: декабрь на Дворцовой площади",
          "Эрмитаж без очередей: январь-февраль — лучшее время",
          "Царское зимой: заснеженные парки и сказочная тишина",
          "«Паруса»: заснеженные купола в окне + глинтвейн = петербургская зима"
        ]
      },
      {
        "heading": "Зимний маршрут в Петербурге",
        "body": "Утро: Эрмитаж (без очередей, купите билет онлайн). Обед: бизнес-ланч в «Парусах» — вид на заснеженный центр. После обеда: Казанский собор → прогулка по Невскому → согреться кофе в кофейне. Вечер: ужин в «Парусах» — ночной зимний Петербург в окне.",
        "highlight": "Декабрь в «Парусах»: рождественское меню + праздничное оформление + ночной вид на Петербург в гирляндах. Лучший петербургский зимний вечер."
      },
      {
        "heading": "Как одеваться в Петербурге зимой",
        "body": "Петербург зимой — влажный и ветреный. Тёплая, водонепроницаемая куртка. Шапка и шарф (ветер особенно сильный у Невы). Удобная непромокаемая обувь. Слои — переходите из улицы в музей и обратно. В ресторане (тёплый зал) — снять тяжёлую куртку в гардероб."
      }
    ],
    "cta": {
      "text": "Забронировать зимний ужин с видом",
      "href": "/"
    }
  },
  {
    "slug": "russkie-muzei-peterburg-gid",
    "title": "Музеи Санкт-Петербурга: путеводитель по главным",
    "metaTitle": "Музеи Санкт-Петербурга — путеводитель | Паруса на крыше",
    "metaDescription": "Музеи Санкт-Петербурга: путеводитель. Эрмитаж, Русский музей, Кунсткамера, Петергоф. Где поесть после музея? «Паруса на крыше» — рядом с центром.",
    "keywords": "музеи санкт-петербург путеводитель, топ музеи спб, лучшие музеи петербурга",
    "date": "2026-06-06",
    "category": "Путеводитель по СПб",
    "readTime": 8,
    "image": "/photos/view_day.webp",
    "lead": "Петербург — музейная столица России. Более 200 музеев, из которых около 30 — мирового уровня. Вот путеводитель по главным с практическими советами.",
    "sections": [
      {
        "heading": "Топ-7 музеев Петербурга",
        "body": "1. Эрмитаж — главный, 3 млн экспонатов, 1–2 дня. 2. Русский музей — крупнейшая коллекция русского искусства. 3. Кунсткамера — первый российский музей, коллекция Петра I. 4. Петропавловская крепость — история, усыпальница Романовых. 5. Исаакиевский собор — шедевр архитектуры + колоннада. 6. Петергоф — дворец и фонтаны (20 км от центра). 7. Царское Село — Янтарная комната (25 км от центра).",
        "list": [
          "Эрмитаж: билет онлайн, 400–800 ₽, 3–4 часа",
          "Русский музей: 400–600 ₽, 2–3 часа",
          "Кунсткамера: 350 ₽, 1,5–2 часа",
          "Петропавловка: от 300 ₽, 2–3 часа"
        ]
      },
      {
        "heading": "Практические советы по музеям",
        "body": "Покупайте билеты онлайн: Эрмитаж, Русский музей, Царское Село (Янтарная комната) — везде продают онлайн и без очереди. Приходите рано: лучшее время — 10:00 в будни. Не берите гидов у входа: в музеях есть официальные экскурсионные группы и аудиогиды. После 4 часов в музее — отдыхайте.",
        "highlight": "Чередуйте музеи с прогулками и едой. Ланч в «Парусах» после Эрмитажа — лучший способ перезагрузиться перед вторым половиной дня."
      },
      {
        "heading": "Маршрут по двум музеям в день",
        "body": "Утро (10:00–13:00): Эрмитаж (главные залы). Ланч (13:00–14:00): бизнес-ланч в «Парусах» от 590 ₽. После обеда (14:00–17:00): Русский музей или Михайловский замок. Вечер (19:30): ужин в «Парусах» с видом. Итого: два музея + два посещения ресторана с видом на Петербург = идеальный культурный день."
      }
    ],
    "cta": {
      "text": "Запланировать ужин между музеями",
      "href": "/menu"
    }
  },
  {
    "slug": "teatr-filarmonia-peterburg-gid",
    "title": "Театры и филармония Петербурга: гид для туриста",
    "metaTitle": "Театры и филармония Петербурга — гид | Паруса на крыше",
    "metaDescription": "Театры и Филармония Санкт-Петербурга: путеводитель. Мариинский, БДТ, Александринский. Где поужинать до театра? «Паруса на крыше» — ужин перед спектаклем.",
    "keywords": "театры петербург гид туристу, мариинский театр петербург, БДТ петербург, ужин перед театром спб",
    "date": "2026-06-06",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Петербург — театральная столица России. Мариинский, БДТ, Александринский, Михайловский — мировые сцены. Вечер в театре — особое петербургское удовольствие.",
    "sections": [
      {
        "heading": "Главные театры Петербурга",
        "body": "Мариинский театр (Театральная пл., 1): балет и опера мирового уровня. Билеты от 500 до 20 000 ₽. Новая сцена Мариинского — современный зал с хорошей акустикой. Большой Драматический Театр (наб. Фонтанки, 65): лучшая драматическая труппа города. Александринский театр (пл. Островского, 6): старейший драматический театр России. Михайловский театр (пл. Искусств, 1): балет и опера, часто лучшая цена-качество.",
        "list": [
          "Мариинский: ballet.ru — покупайте онлайн",
          "БДТ: bdt.spb.ru — русская классика",
          "Александринский: alexandrinsky.ru — исторические постановки",
          "Михайловский: mikhailovsky.ru — доступные цены на балет"
        ]
      },
      {
        "heading": "Ужин до театра: где и когда",
        "body": "Оптимальный тайминг: ужин за 2 часа до начала спектакля. Например, спектакль в 19:00 → ужин в 17:00–18:30. «Паруса на крыше» — отличное место до театра: авторская кухня с видом на Петербург. До Мариинского: 15 минут на такси. До Александринского: 7 минут пешком.",
        "highlight": "Ужин в «Парусах» до Александринского: идеальный тайминг для раннего ужина (17:30–18:30) + прогулка по Невскому + театр. Бронируйте оба заранее."
      },
      {
        "heading": "После театра: куда идти",
        "body": "После вечернего спектакля (обычно 22:00–22:30): рестораны центра ещё работают. «Паруса» — уточните время работы при бронировании. Ул. Рубинштейна — поздние рестораны и бары. Набережная Невы — прогулка и ночной Петербург."
      }
    ],
    "cta": {
      "text": "Забронировать ужин до театра",
      "href": "/"
    }
  },
  {
    "slug": "nochnoy-peterburg-chto-delat",
    "title": "Ночной Петербург: что делать и куда пойти",
    "metaTitle": "Ночной Петербург — что делать и куда пойти | Паруса на крыше",
    "metaDescription": "Ночная жизнь Санкт-Петербурга: рестораны, прогулки, разводка мостов. «Паруса на крыше» — ужин с ночным видом на Петербург, вечерняя программа.",
    "keywords": "ночной петербург что делать, ночь петербург куда идти, ночная жизнь петербург",
    "date": "2026-06-07",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Петербург не засыпает — особенно летом. Белые ночи, разводка мостов, ночные рестораны и прогулки по набережным создают уникальную ночную атмосферу.",
    "sections": [
      {
        "heading": "Что делать ночью в Петербурге",
        "body": "21:00–23:00: ужин в ресторане с видом. «Паруса» работают вечером — узнайте время закрытия при бронировании. 01:00–05:00: разводка мостов (Дворцовый, Благовещенский, Литейный, Троицкий). Лучшие точки: набережная Невы у мостов. В белые ночи (июнь): просто гулять по набережной в 23:00–02:00 — небо светлое, город спит минимально.",
        "list": [
          "Ужин с ночным видом в «Парусах»: рекомендуем 19:00–22:00",
          "Разводка мостов: Благовещенский 01:25, Дворцовый 01:35",
          "Ночные прогулки по набережной: с 22:00 до рассвета",
          "В белые ночи: набережная Невы в 00:00 — особенная атмосфера"
        ]
      },
      {
        "heading": "Ночной вид на Петербург с высоты",
        "body": "Ночной Петербург с 6-го этажа Olympic Plaza — особенное зрелище. Огни подсветки Казанского собора, иллюминация куполов, ночные огни центра. Если успеете на ужин в «Парусах» до 22:00 летом — застанете переход от заката к ночному городу.",
        "highlight": "Самый красивый ночной вид: «Паруса» в 22:00 летом. Белая ночь за окном, огни города внизу — это нельзя снять на телефон, это нужно пережить."
      },
      {
        "heading": "Ночные маршруты",
        "body": "Маршрут 1 (Мосты): набережная Невы у Зимнего → Благовещенский мост → смотреть разводку → прогулка обратно. Маршрут 2 (Белые ночи): Спас на Крови → набережная Мойки → Певческий мост → набережная Невы. Маршрут 3 (Романтика): прогулка по каналу Грибоедова → разводка мостов вместе."
      }
    ],
    "cta": {
      "text": "Забронировать ночной ужин с видом",
      "href": "/"
    }
  },
  {
    "slug": "ostrovа-spb-elagin-krestovsky",
    "title": "Острова Петербурга: Елагин, Крестовский — что посмотреть",
    "metaTitle": "Острова Петербурга: Елагин и Крестовский | Паруса на крыше",
    "metaDescription": "Острова Санкт-Петербурга: Елагин остров, Крестовский. Что посмотреть, как добраться. Где поужинать после прогулки — «Паруса на крыше».",
    "keywords": "острова петербурга елагин крестовский, елагин остров петербург, крестовский остров спб",
    "date": "2026-06-07",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_summer.webp",
    "lead": "Острова Петербурга — зелёные лёгкие города. Елагин и Крестовский острова предлагают парки, набережные и смену темпа после городской суеты.",
    "sections": [
      {
        "heading": "Елагин остров: парк для отдыха",
        "body": "Елагин остров — самый красивый парк Петербурга. Елагиноостровский дворец (вход платный), прогулки по аллеям и берегу Финского залива, закаты с западного берега — лучшие в городе. Как добраться: метро Крестовский остров или Старая Деревня + пешком. Время: 2–4 часа.",
        "list": [
          "Дворец Елагина: интерьеры 19 века",
          "Закат с западного берега: лучший в Петербурге (летом 22:00)",
          "Пляж: летом петербуржцы загорают",
          "Парк работает до 23:00, дворец до 18:00"
        ]
      },
      {
        "heading": "Крестовский остров: активный отдых",
        "body": "Крестовский остров — спортивный и ресторанный центр. Стадион «Газпром Арена» — крупнейший в России. Парк Победы (часть острова). Ресторанные набережные и летние веранды. Как добраться: метро Крестовский остров.",
        "highlight": "Закат на Елагином острове → ужин в «Парусах» = идеальный петербургский вечер. 20 минут на метро от Старой Деревни до Маяковской."
      },
      {
        "heading": "Как включить острова в маршрут",
        "body": "Острова — дополнение, а не замена центру. Включайте в маршрут на 3–4-й день, когда центральные достопримечательности уже посмотрены. Полдня на Елагином → возвращение в центр → ужин в «Парусах» = хороший ритм дня без усталости."
      }
    ],
    "cta": {
      "text": "Забронировать ужин после островов",
      "href": "/"
    }
  },
  {
    "slug": "dvortsovaya-ploshchad-peterburg",
    "title": "Дворцовая площадь в Петербурге: история и как посетить",
    "metaTitle": "Дворцовая площадь в Петербурге — история и посещение | Паруса",
    "metaDescription": "Дворцовая площадь в Санкт-Петербурге: история, что смотреть, как добраться. После Дворцовой площади — ужин в «Парусах на крыше» с видом на Казанский собор.",
    "keywords": "дворцовая площадь петербург история, дворцовая площадь что смотреть, дворцовая площадь как добраться",
    "date": "2026-06-08",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Дворцовая площадь — сердце Петербурга. Здесь Зимний дворец, Александровская колонна и ощущение имперского масштаба, которого нет нигде больше в России.",
    "sections": [
      {
        "heading": "Что смотреть на Дворцовой площади",
        "body": "Зимний дворец (Эрмитаж): главный вход — через Иорданский подъезд. Александровская колонна: центр площади, 47 метров высоты, без единого болта. Главный штаб: арка с Триумфальной колесницей, внутри — современное искусство Эрмитажа. Площадь как таковая: лучший вид утром, до открытия Эрмитажа (до 10:00).",
        "list": [
          "Эрмитаж — главное, 3–4 часа",
          "Александровская колонна: ближайший ракурс для фото — угол площади",
          "Главный штаб: пройдите через арку, посмотрите на площадь изнутри",
          "Утром до 9:00: пустая площадь, лучшие фото"
        ]
      },
      {
        "heading": "Маршрут от Дворцовой до «Парусов»",
        "body": "Дворцовая площадь → пешком по Невскому 2,5 км (30 минут, через Казанский собор) → ул. Марата → Olympic Plaza → «Паруса на крыше». Или такси: 7 минут, 300–400 ₽. После Дворцовой площади ужин с видом на Казанский собор — закрыть «петербургский круг» за один день.",
        "highlight": "Лучшие фото на Дворцовой: рано утром (08:00–09:00) когда нет туристов и золотой утренний свет. Потом — на Эрмитаж к 10:00."
      },
      {
        "heading": "Дворцовая площадь в разные сезоны",
        "body": "Зимой: площадь со снегом — одна из красивейших в мире, рождественская ярмарка в декабре. Летом: туристы, жара, белые ночи — открытые концерты по праздникам. Осенью: дождь, пустая, осенняя меланхолия — для фотографов и романтиков. Весной: первое тепло, тающий снег, возвращение жизни."
      }
    ],
    "cta": {
      "text": "Забронировать ужин после Дворцовой площади",
      "href": "/"
    }
  },
  {
    "slug": "spas-na-krovi-peterburg-muzei",
    "title": "Спас на Крови в Петербурге: история и как посетить",
    "metaTitle": "Спас на Крови в Петербурге — история и посещение | Паруса",
    "metaDescription": "Спас на Крови в Санкт-Петербурге: история, мозаики, как посетить. Где поесть рядом? «Паруса на крыше» — 10 минут от Спаса на Крови.",
    "keywords": "спас на крови петербург история, спас на крови как посетить, спас на крови что смотреть",
    "date": "2026-06-08",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Спас на Крови — самый необычный храм Петербурга. Русский стиль в европейском городе, мозаики на весь интерьер и история, связанная с убийством Александра II.",
    "sections": [
      {
        "heading": "История Спаса на Крови",
        "body": "Храм построен на месте гибели Александра II (1881) — именно поэтому «на крови». Освящён в 1907 году. Стиль: русское возрождение — в окружении европейской застройки центра выглядит как чужестранец, что и делает его особенным. Интерьер: крупнейшая в мире коллекция мозаики — 7 000 кв.м., все стены и потолки.",
        "list": [
          "Площадь мозаик: 7 000 кв.м. — самая большая коллекция в мире",
          "Вход от 350–500 ₽, онлайн без очереди",
          "Внутри фотографировать можно — свет меняется в течение дня",
          "Лучший вид снаружи: с противоположного берега канала Грибоедова"
        ]
      },
      {
        "heading": "Как посетить: советы",
        "body": "Билеты онлайн на museumsrussia.ru. Лучший свет внутри: 11:00–14:00 (дневной свет через окна). Экскурсия или аудиогид: мозаики имеют историю и без пояснений теряют смысл. Время посещения: 1–1,5 часа.",
        "highlight": "Самый красивый вид на Спас на Крови: с противоположного берега канала Грибоедова в отражении воды. Это открытка, которую покупают туристы."
      },
      {
        "heading": "Что рядом со Спасом на Крови",
        "body": "Михайловский сад: сразу за храмом, бесплатно. Русский музей: 5 минут пешком (площадь Искусств). «Паруса на крыше»: 10 минут пешком (через Михайловский сад → ул. Марата → Olympic Plaza). После Спаса на Крови ужин с видом на Петербург — хорошее завершение культурного дня."
      }
    ],
    "cta": {
      "text": "Забронировать ужин после Спаса на Крови",
      "href": "/"
    }
  },
  {
    "slug": "belie-nochi-peterburg-kogda-kak",
    "title": "Белые ночи в Петербурге: когда, что смотреть и где встречать",
    "metaTitle": "Белые ночи в Петербурге — когда и где встречать | Паруса на крыше",
    "metaDescription": "Белые ночи в Санкт-Петербурге: когда начинаются, что смотреть, где встречать. «Паруса на крыше» — открытая терраса в белые ночи, вид на светлое небо.",
    "keywords": "белые ночи петербург когда, белые ночи петербург 2026, белые ночи спб когда начинаются",
    "date": "2026-06-09",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Белые ночи — главное природное явление Петербурга и одна из главных причин, по которым в город едут летом. Что это такое, когда лучше всего и как провести эти вечера.",
    "sections": [
      {
        "heading": "Что такое белые ночи",
        "body": "Белые ночи в Петербурге — период, когда солнце заходит так ненадолго и так мелко за горизонт, что на улице не темнеет. Длятся примерно с 25 мая по 16 июля. Пик — 21–24 июня (самые светлые дни). В это время в 00:30–01:00 ночи на улице светло как вечером. Для гостей из других регионов это поначалу дезориентирует, но быстро становится одним из главных впечатлений.",
        "list": [
          "Начало: примерно 25 мая",
          "Пик: 21–24 июня",
          "Конец: примерно 16 июля",
          "Самые светлые ночи: в 00:30 видно читать"
        ]
      },
      {
        "heading": "Где лучше всего встречать белые ночи",
        "body": "Набережная Невы: классика, но толпа. Разводка мостов: Благовещенский в 01:25 — наблюдать с набережной. Крыши (экскурсионные): красиво, но только летом и только обзорно. Открытая терраса «Парусов»: светлое небо в 23:00 + вид на купола + ужин. Это самая комфортная версия «белых ночей» — без стояния на набережной.",
        "highlight": "Белые ночи на террасе «Парусов»: ужин в 22:00 под светлым небом июня. Небо меняет цвет с белого через розовый к жемчужному — прямо за вашим столиком. Бронируйте за 2–3 недели."
      },
      {
        "heading": "Программа вечера белых ночей",
        "body": "19:30: ужин в «Парусах» → 22:00: прогулка по набережной → 01:00: разводка Благовещенского моста → прогулка обратно. Итого: вечер без усталости, потому что вовремя поужинали и сохранили силы для прогулки."
      }
    ],
    "cta": {
      "text": "Забронировать ужин в белые ночи",
      "href": "/"
    }
  }
];
